import { Suspense } from 'components/common/Suspense/index.js';
import {
  AuthLayout,
  GettingStarted,
  JoinFormType,
  RegisterCRForm,
  RegisterFormPage,
} from 'features/onboarding-auth/index.js';
import { Route } from 'react-router';
import { RoutePaths } from 'shared/routes.js';

export const RegisterRouter = (
  <Route path={RoutePaths.REGISTER} element={<AuthLayout />}>
    <Route
      path={RoutePaths.REGISTER_AR()}
      element={(
        <Suspense>
          <RegisterFormPage joinFormType={JoinFormType.JoinAR} />
        </Suspense>
      )}
    />
    <Route
      path={RoutePaths.REGISTER_RA()}
      element={(
        <Suspense>
          <RegisterFormPage joinFormType={JoinFormType.JoinRA} />
        </Suspense>
      )}
    />
    <Route
      path={RoutePaths.REGISTER_CR}
      element={(
        <Suspense>
          <GettingStarted />
        </Suspense>
      )}
    />
    <Route
      path={RoutePaths.REGISTER_CR_CREATE_COMPANY()}
      element={(
        <Suspense>
          <RegisterCRForm />
        </Suspense>
      )}
    />
    <Route
      path={RoutePaths.REGISTER_CR_JOIN_COMPANY()}
      element={(
        <Suspense>
          <RegisterFormPage joinFormType={JoinFormType.JoinCR} />
        </Suspense>
      )}
    />
  </Route>
);
